import { combineReducers } from '@reduxjs/toolkit';
import usersReducer from '../features/users/slice';
import termsReducer from '../features/terms/slice';
import invoicesReducer from '../features/invoices/slice';

const rootReducer = combineReducers({
  users: usersReducer,
  terms: termsReducer,
  invoices: invoicesReducer,
  // Add other reducers here
});

export default rootReducer;
